import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { SnackbarProvider, useSnackbar } from 'notistack'
import Slide from '@material-ui/core/Slide'

function SlideTransition(props) {
  return <Slide {...props} direction="right" />
}

function SnackReduxProvider({ children = {} }) {
  const { snack = {} } = useSelector((state) => state)
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    if (snack?.text) enqueueSnackbar(snack?.text, { autoHideDuration: 1500, ...snack })
  }, [snack])

  return children
}

SnackReduxProvider.prototype = {
  children: PropTypes.children,
}

export default function SnackBarWrapper({ children = {} }) {
  return (
    <SnackbarProvider
      TransitionComponent={SlideTransition}
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      <SnackReduxProvider>
        {children}
      </SnackReduxProvider>
    </SnackbarProvider>
  )
}

SnackBarWrapper.prototype = {
  children: PropTypes.children,
}
